import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import headerImage from "../../images/thumbnail_lsc-menu@2x.png";
import { jointAccountMap } from "./DirectDebitDetails";

const styles = StyleSheet.create({
  page: {
    fontSize: 16,
  },
  header: {
    borderBottom: "1pt solid #D6D6D6",
    padding: "24 40",
  },
  headerImage: {
    width: 164,
  },
  main: {
    padding: 40,
  },
  title: {
    fontSize: 24,
  },
  alert: {
    marginTop: 32,
    padding: 16,
    backgroundColor: "#EFF7FF",
  },
  card: {
    marginTop: 32,
    padding: 16,
    backgroundColor: "#F2F2F2",
    display: "flex",
    flexDirection: "row",
  },
  cardImage: {
    width: 52,
    height: 44,
    marginRight: 16,
  },
  cardEnding: {
    marginTop: 8,
  },
  table: {
    marginTop: 32,
    padding: 16,
    border: "1pt solid #D6D6D6",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 24,
  },
  firstRow: {
    paddingTop: 0,
  },
  label: {
    width: 280,
  },
  value: {
    width: 180,
  },
});

export const DirectDebitRequestDetailsPdf = ({
  cardName,
  cardEndsWith,
  accountName,
  jointAccount,
  bankName,
  bsb,
  accountNumber,
}) => (
  <Document>
    <Page style={styles.page}>
      <View style={styles.header}>
        <Image style={styles.headerImage} src={headerImage} />
      </View>
      <View style={styles.main}>
        <Text style={styles.title}>Direct debit request</Text>
        <View style={styles.card}>
          <Image
            style={styles.cardImage}
            src={require("../../images/credit-card.png").default}
          />
          <View>
            <Text>{cardName}</Text>
            <Text style={styles.cardEnding}>Card ending {cardEndsWith}</Text>
          </View>
        </View>
        <View style={styles.alert}>
          <Text>
            Direct debit will start from your next statement due date. Please
            make a payment for your current statement if you have not already
            done so.
          </Text>
        </View>
        <View style={styles.table}>
          <View style={{ ...styles.row, ...styles.firstRow }}>
            <Text style={styles.label}>Name of account to be debited</Text>
            <Text style={styles.value}>{accountName}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Joint account</Text>
            <Text style={styles.value}>{jointAccountMap[jointAccount]}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Bank name</Text>
            <Text style={styles.value}>{bankName}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>BSB</Text>
            <Text style={styles.value}>{bsb}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Account number</Text>
            <Text style={styles.value}>{accountNumber}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Payment amount</Text>
            <Text style={styles.value}>
              Minimum monthly payment + any overdue and overlimit amount
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Monthly debit date</Text>
            <Text style={styles.value}>
              Starting from your next statement due date
            </Text>
          </View>
        </View>
      </View>
    </Page>
  </Document>
);
